/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ContentZoneContext } from "cms/components/context";
import { isEmpty } from "lodash";
import { Fragment, useContext } from "react";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { CardsItemDisplay } from "./cards-simple-item";

const CardsComponentDisplay = () => {
    const ctx = useContext(ContentZoneContext);
    const component = ctx?.component;
    const card_list = component?.card_list;
    const hasContent = !isEmpty(card_list);

    return (
        <Fragment>
            <EmptyContentMessage hasContent={hasContent} component={component} />
            {hasContent && (
                <Fragment>
                    <div className="cards-content">
                        {card_list.map((item, index) => (
                            <div className="cards-content-item" key={index}>
                                <CardsItemDisplay item={item} />
                            </div>
                        ))}
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

CardsComponentDisplay.displayName = "CardsComponentDisplay";
export { CardsComponentDisplay };
